import { Stack, Typography } from '@mui/material';
import parse from 'html-react-parser';
import { ResponsiveText, responsiveTextParseOptions } from '@treedis/tour-loader';

type Props = {
  text: string;
  tour: any;
};

export function Summary({ text, tour }: Props) {
  return (
    <Stack spacing={2}>
      <Typography variant="h5">{tour?.translation?.summary || 'Summary'}</Typography>
      <ResponsiveText>{parse(text, responsiveTextParseOptions)}</ResponsiveText>
    </Stack>
  );
}
